"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _gridStyled = require("grid-styled");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _utils = require("@gravity/utils");
var _themeProvider = require("@gravity/theme-provider");
var _jsxFileName = "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/CollapsiblePanel/lib/CollapsiblePanel.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_w2bos73zg() {
  var path = "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/CollapsiblePanel/lib/CollapsiblePanel.js";
  var hash = "f102a460bc744ff73fc0b1611a5d0694e22b4852";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/CollapsiblePanel/lib/CollapsiblePanel.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 23,
          column: 13
        }
      },
      "2": {
        start: {
          line: 26,
          column: 20
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "3": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 36,
          column: 13
        }
      },
      "4": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 42,
          column: 13
        }
      },
      "5": {
        start: {
          line: 49,
          column: 18
        },
        end: {
          line: 95,
          column: 2
        }
      },
      "6": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 60,
          column: 15
        }
      },
      "7": {
        start: {
          line: 62,
          column: 25
        },
        end: {
          line: 62,
          column: 59
        }
      },
      "8": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 68,
          column: 15
        }
      },
      "9": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 74,
          column: 15
        }
      },
      "10": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 84,
          column: 15
        }
      },
      "11": {
        start: {
          line: 86,
          column: 25
        },
        end: {
          line: 86,
          column: 59
        }
      },
      "12": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 92,
          column: 15
        }
      },
      "13": {
        start: {
          line: 97,
          column: 27
        },
        end: {
          line: 99,
          column: 4
        }
      },
      "14": {
        start: {
          line: 101,
          column: 26
        },
        end: {
          line: 105,
          column: 1
        }
      },
      "15": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 17
        }
      },
      "16": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 116,
          column: 6
        }
      },
      "17": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 63
        }
      },
      "18": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 61
        }
      },
      "19": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 85
        }
      },
      "20": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "21": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 56
        }
      },
      "22": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 135,
          column: 9
        }
      },
      "23": {
        start: {
          line: 140,
          column: 15
        },
        end: {
          line: 140,
          column: 17
        }
      },
      "24": {
        start: {
          line: 142,
          column: 22
        },
        end: {
          line: 142,
          column: 45
        }
      },
      "25": {
        start: {
          line: 143,
          column: 21
        },
        end: {
          line: 143,
          column: 40
        }
      },
      "26": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 152,
          column: 5
        }
      },
      "27": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 24
        }
      },
      "28": {
        start: {
          line: 147,
          column: 11
        },
        end: {
          line: 152,
          column: 5
        }
      },
      "29": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 27
        }
      },
      "30": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 151,
          column: 7
        }
      },
      "31": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 150,
          column: 27
        }
      },
      "32": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 164,
          column: 6
        }
      },
      "33": {
        start: {
          line: 168,
          column: 0
        },
        end: {
          line: 185,
          column: 2
        }
      },
      "34": {
        start: {
          line: 187,
          column: 0
        },
        end: {
          line: 191,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 19
          }
        },
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 23,
            column: 13
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 31,
            column: 12
          }
        },
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 36,
            column: 13
          }
        },
        line: 32
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 22
          },
          end: {
            line: 37,
            column: 23
          }
        },
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 42,
            column: 13
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 55,
            column: 20
          },
          end: {
            line: 55,
            column: 21
          }
        },
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 60,
            column: 15
          }
        },
        line: 56
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 62,
            column: 15
          },
          end: {
            line: 62,
            column: 16
          }
        },
        loc: {
          start: {
            line: 62,
            column: 25
          },
          end: {
            line: 62,
            column: 59
          }
        },
        line: 62
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 63,
            column: 13
          },
          end: {
            line: 63,
            column: 14
          }
        },
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 68,
            column: 15
          }
        },
        line: 64
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 25
          }
        },
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 74,
            column: 15
          }
        },
        line: 70
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 79,
            column: 21
          }
        },
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 84,
            column: 15
          }
        },
        line: 80
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 86,
            column: 15
          },
          end: {
            line: 86,
            column: 16
          }
        },
        loc: {
          start: {
            line: 86,
            column: 25
          },
          end: {
            line: 86,
            column: 59
          }
        },
        line: 86
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 87,
            column: 13
          },
          end: {
            line: 87,
            column: 14
          }
        },
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 92,
            column: 15
          }
        },
        line: 88
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 21
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 112
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        loc: {
          start: {
            line: 123,
            column: 21
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 123
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 22
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 129
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        },
        loc: {
          start: {
            line: 139,
            column: 11
          },
          end: {
            line: 165,
            column: 3
          }
        },
        line: 139
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 23,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 5
          },
          end: {
            line: 19,
            column: 10
          }
        }, {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 17
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 34
          }
        }, {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 46
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 13
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 36,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 5
          },
          end: {
            line: 32,
            column: 10
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 17
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 34
          }
        }, {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 50
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 13
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 42,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 5
          },
          end: {
            line: 38,
            column: 10
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 17
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 34
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 48
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 13
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 60,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 7
          },
          end: {
            line: 56,
            column: 12
          }
        }, {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 19
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 36
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 48
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 60,
            column: 15
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 25
          },
          end: {
            line: 62,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 43
          },
          end: {
            line: 62,
            column: 49
          }
        }, {
          start: {
            line: 62,
            column: 52
          },
          end: {
            line: 62,
            column: 59
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 68,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 7
          },
          end: {
            line: 64,
            column: 12
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 19
          }
        }, {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 36
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 50
          }
        }, {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 15
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 74,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 7
          },
          end: {
            line: 70,
            column: 12
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 19
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 36
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 48
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 15
          }
        }],
        line: 70
      },
      "7": {
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 84,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 80,
            column: 12
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 19
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 36
          }
        }, {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 48
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 15
          }
        }],
        line: 80
      },
      "8": {
        loc: {
          start: {
            line: 86,
            column: 25
          },
          end: {
            line: 86,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 43
          },
          end: {
            line: 86,
            column: 49
          }
        }, {
          start: {
            line: 86,
            column: 52
          },
          end: {
            line: 86,
            column: 59
          }
        }],
        line: 86
      },
      "9": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 92,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 7
          },
          end: {
            line: 88,
            column: 12
          }
        }, {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 19
          }
        }, {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 36
          }
        }, {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 91,
            column: 50
          }
        }, {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 15
          }
        }],
        line: 88
      },
      "10": {
        loc: {
          start: {
            line: 124,
            column: 11
          },
          end: {
            line: 124,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 41
          },
          end: {
            line: 124,
            column: 61
          }
        }, {
          start: {
            line: 124,
            column: 64
          },
          end: {
            line: 124,
            column: 84
          }
        }],
        line: 124
      },
      "11": {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }, {
          start: {
            line: 132,
            column: 11
          },
          end: {
            line: 136,
            column: 5
          }
        }],
        line: 130
      },
      "12": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: 147,
            column: 11
          },
          end: {
            line: 152,
            column: 5
          }
        }],
        line: 145
      },
      "13": {
        loc: {
          start: {
            line: 147,
            column: 11
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 11
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 147
      },
      "14": {
        loc: {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 149
      },
      "15": {
        loc: {
          start: {
            line: 159,
            column: 39
          },
          end: {
            line: 159,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 159,
            column: 51
          },
          end: {
            line: 159,
            column: 57
          }
        }, {
          start: {
            line: 159,
            column: 60
          },
          end: {
            line: 159,
            column: 64
          }
        }],
        line: 159
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0, 0, 0, 0],
      "3": [0, 0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0, 0, 0, 0],
      "6": [0, 0, 0, 0, 0],
      "7": [0, 0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f102a460bc744ff73fc0b1611a5d0694e22b4852"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_w2bos73zg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_w2bos73zg();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PanelWrapper = (cov_w2bos73zg().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-CollapsiblePanel'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n"])), _stylingConstants.default.border.widthBase, function (props) {
  cov_w2bos73zg().f[0]++;
  cov_w2bos73zg().s[1]++;
  return (cov_w2bos73zg().b[0][0]++, props) && (cov_w2bos73zg().b[0][1]++, props.theme) && (cov_w2bos73zg().b[0][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[0][3]++, props.theme.collapsiblePanel.borderColor) || (cov_w2bos73zg().b[0][4]++, '#E6E6E6');
}));
var PanelHeader = (cov_w2bos73zg().s[2]++, (0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'g-CollapsiblePanel-header'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  position: relative;\n  color: ", ";\n  background-color: ", ";\n  justify-content: space-between;\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (props) {
  cov_w2bos73zg().f[1]++;
  cov_w2bos73zg().s[3]++;
  return (cov_w2bos73zg().b[1][0]++, props) && (cov_w2bos73zg().b[1][1]++, props.theme) && (cov_w2bos73zg().b[1][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[1][3]++, props.theme.collapsiblePanel.headerTextColor) || (cov_w2bos73zg().b[1][4]++, '#3B3D40');
}, function (props) {
  cov_w2bos73zg().f[2]++;
  cov_w2bos73zg().s[4]++;
  return (cov_w2bos73zg().b[2][0]++, props) && (cov_w2bos73zg().b[2][1]++, props.theme) && (cov_w2bos73zg().b[2][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[2][3]++, props.theme.collapsiblePanel.headerBgColor) || (cov_w2bos73zg().b[2][4]++, '#FFFFFF');
}));
var PanelBody = (cov_w2bos73zg().s[5]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-CollapsiblePanel-body'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    border-width: 0;\n    border-style: solid;\n    border-color: ", ";\n    width: 100%;\n    display: ", ";\n    color: ", ";\n    background-color: ", ";\n  "])), function (props) {
  cov_w2bos73zg().f[3]++;
  cov_w2bos73zg().s[6]++;
  return (cov_w2bos73zg().b[3][0]++, props) && (cov_w2bos73zg().b[3][1]++, props.theme) && (cov_w2bos73zg().b[3][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[3][3]++, props.theme.collapsiblePanel.borderColor) || (cov_w2bos73zg().b[3][4]++, '#E6E6E6');
}, function (props) {
  cov_w2bos73zg().f[4]++;
  cov_w2bos73zg().s[7]++;
  return props.collapsed ? (cov_w2bos73zg().b[4][0]++, 'none') : (cov_w2bos73zg().b[4][1]++, 'block');
}, function (props) {
  cov_w2bos73zg().f[5]++;
  cov_w2bos73zg().s[8]++;
  return (cov_w2bos73zg().b[5][0]++, props) && (cov_w2bos73zg().b[5][1]++, props.theme) && (cov_w2bos73zg().b[5][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[5][3]++, props.theme.collapsiblePanel.bodyTextColor) || (cov_w2bos73zg().b[5][4]++, '#3B3D40');
}, function (props) {
  cov_w2bos73zg().f[6]++;
  cov_w2bos73zg().s[9]++;
  return (cov_w2bos73zg().b[6][0]++, props) && (cov_w2bos73zg().b[6][1]++, props.theme) && (cov_w2bos73zg().b[6][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[6][3]++, props.theme.collapsiblePanel.bodyBgColor) || (cov_w2bos73zg().b[6][4]++, '#FFFFFF');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    border-width: 0;\n    border-style: solid;\n    border-color: ", ";\n    width: 100%;\n    display: ", ";\n    color: ", ";\n    background-color: #FFFFFF;\n  "])), function (props) {
  cov_w2bos73zg().f[7]++;
  cov_w2bos73zg().s[10]++;
  return (cov_w2bos73zg().b[7][0]++, props) && (cov_w2bos73zg().b[7][1]++, props.theme) && (cov_w2bos73zg().b[7][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[7][3]++, props.theme.collapsiblePanel.borderColor) || (cov_w2bos73zg().b[7][4]++, '#E6E6E6');
}, function (props) {
  cov_w2bos73zg().f[8]++;
  cov_w2bos73zg().s[11]++;
  return props.collapsed ? (cov_w2bos73zg().b[8][0]++, 'none') : (cov_w2bos73zg().b[8][1]++, 'block');
}, function (props) {
  cov_w2bos73zg().f[9]++;
  cov_w2bos73zg().s[12]++;
  return (cov_w2bos73zg().b[9][0]++, props) && (cov_w2bos73zg().b[9][1]++, props.theme) && (cov_w2bos73zg().b[9][2]++, props.theme.collapsiblePanel) && (cov_w2bos73zg().b[9][3]++, props.theme.collapsiblePanel.bodyTextColor) || (cov_w2bos73zg().b[9][4]++, '#3B3D40');
}))));
var HeaderTitleWrapper = (cov_w2bos73zg().s[13]++, (0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'g-collapsiblePanel-header-title'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)([""]))));
var HeaderIconWrapper = (cov_w2bos73zg().s[14]++, (0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'g-collapsiblePanel-header-icon'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  margin: auto 0;\n"]))));

/**
 * Component that generate a panel with a header and a body,
 * when clicking on the header, it collapse or show the body
 */
var CollapsiblePanel = /*#__PURE__*/function (_React$Component) {
  function CollapsiblePanel(props) {
    var _this;
    (0, _classCallCheck2.default)(this, CollapsiblePanel);
    cov_w2bos73zg().f[10]++;
    cov_w2bos73zg().s[15]++;
    _this = _callSuper(this, CollapsiblePanel, [props]);
    cov_w2bos73zg().s[16]++;
    _this.state = {
      collapsed: props.collapsed
    };
    // bind function for future use
    cov_w2bos73zg().s[17]++;
    _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
    cov_w2bos73zg().s[18]++;
    _this.getCollapseState = _this.getCollapseState.bind(_this);
    return _this;
  }

  // get the collapsed value from state or props depending which component handle the state
  (0, _inherits2.default)(CollapsiblePanel, _React$Component);
  return (0, _createClass2.default)(CollapsiblePanel, [{
    key: "getCollapseState",
    value: function getCollapseState() {
      cov_w2bos73zg().f[11]++;
      cov_w2bos73zg().s[19]++;
      return this.props.onCollapseChange ? (cov_w2bos73zg().b[10][0]++, this.props.collapsed) : (cov_w2bos73zg().b[10][1]++, this.state.collapsed);
    }

    // when click on header, even the component is responsible of the state and so update the state
    // either it is the parent, then call the funciton provided with the current collapsed state of body
  }, {
    key: "handleHeaderClick",
    value: function handleHeaderClick() {
      cov_w2bos73zg().f[12]++;
      cov_w2bos73zg().s[20]++;
      if (this.props.onCollapseChange) {
        cov_w2bos73zg().b[11][0]++;
        cov_w2bos73zg().s[21]++;
        this.props.onCollapseChange(this.props.collapsed);
      } else {
        cov_w2bos73zg().b[11][1]++;
        cov_w2bos73zg().s[22]++;
        this.setState({
          collapsed: !this.state.collapsed
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_w2bos73zg().f[13]++;
      var body = (cov_w2bos73zg().s[23]++, '');
      var header;
      var collapsed = (cov_w2bos73zg().s[24]++, this.getCollapseState());
      var children = (cov_w2bos73zg().s[25]++, this.props.children);
      // assign header and body depending on the children
      cov_w2bos73zg().s[26]++;
      if (!(0, _isArray.default)(children)) {
        cov_w2bos73zg().b[12][0]++;
        cov_w2bos73zg().s[27]++;
        header = children;
      } else {
        cov_w2bos73zg().b[12][1]++;
        cov_w2bos73zg().s[28]++;
        if (children.length > 0) {
          cov_w2bos73zg().b[13][0]++;
          cov_w2bos73zg().s[29]++;
          header = children[0];
          cov_w2bos73zg().s[30]++;
          if (children.length > 1) {
            cov_w2bos73zg().b[14][0]++;
            cov_w2bos73zg().s[31]++;
            body = children[1];
          } else {
            cov_w2bos73zg().b[14][1]++;
          }
        } else {
          cov_w2bos73zg().b[13][1]++;
        }
      }
      cov_w2bos73zg().s[32]++;
      return /*#__PURE__*/_react.default.createElement(PanelWrapper, (0, _extends2.default)({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155,
          columnNumber: 7
        }
      }), /*#__PURE__*/_react.default.createElement(PanelHeader, {
        onClick: this.handleHeaderClick,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(HeaderTitleWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 11
        }
      }, header), /*#__PURE__*/_react.default.createElement(HeaderIconWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        iconName: "chevron-".concat(collapsed ? (cov_w2bos73zg().b[15][0]++, 'down') : (cov_w2bos73zg().b[15][1]++, 'up')),
        size: "default",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 13
        }
      }))), /*#__PURE__*/_react.default.createElement(PanelBody, {
        collapsed: collapsed,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 9
        }
      }, body));
    }
  }]);
}((_react.default.Component));
cov_w2bos73zg().s[33]++;
CollapsiblePanel.propTypes = {
  /**
   * collapsed is used to set the initial state of the collapsed body
   * if the onCollapseChange is passed, each update of the component use the props to define if object is collapsed or not
   */
  collapsed: _propTypes.default.bool,
  /**
   * If no function is passed, the component handle state internally.
   * If the function is passed, the parent component must handle the change of collapse state
   * The function is called each time the header is clicked
   * The function take one parameter boolean that represent the current state (i.e. if the component is collapsed, it pass true, and false if it is not collapsed)
   */
  onCollapseChange: _propTypes.default.func,
  /**
   * You must pass exactly two children, the first one will be the header and the second one will be the body
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
cov_w2bos73zg().s[34]++;
CollapsiblePanel.defaultProps = {
  collapsed: false,
  onCollapseChange: undefined,
  children: ''
};
var _default = exports.default = CollapsiblePanel;